<template>
  <div class="category-thumbnails">
    <b-row>
      <category-thumbnail
        name="Beds"
        img-src="/images/categories/category-beds.jpg"
        link-category="beds"/>
      <category-thumbnail
        name="Storage"
        img-src="/images/categories/category-storage.jpg"
        link-category="storage"/>
      <category-thumbnail
        name="Outdoor"
        img-src="/images/categories/category-outdoor.jpg"
        link-category="outdoor"/>
      <category-thumbnail
        name="Seating"
        img-src="/images/categories/category-seating.jpg"
        link-category="seating"/>
    </b-row>
  </div>
</template>

<script>
import CategoryThumbnail from '@/components/listings/CategoryThumbnail.vue'

export default {
  name: 'CategoryThumbnails',
  components: {
    CategoryThumbnail,
  },
}
</script>
